export const generateUniqueRandomString = (length: number): string => {
  const charset: string = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';

  const generateRandomChar = (): string => {
    const randomIndex: number = Math.floor(Math.random() * charset.length);
    return charset.charAt(randomIndex);
  };

  return Array.from({ length }, generateRandomChar).join('');
};

export interface CleanObjectDeepConfig {
  removeUndefined?: boolean;
  removeNull?: boolean;
  removeEmptyString?: boolean;
  removeEmptyObject?: boolean;
}

// thanks, ChatGPT :)
export function cleanObjectDeep<T>(obj: T, config?: CleanObjectDeepConfig): T {
  const {
    removeUndefined = true,
    removeNull = false,
    removeEmptyString = true,
    removeEmptyObject = true,
  } = config || {};

  function filterCallback(value: unknown) {
    if (removeUndefined && value === undefined) {
      return false;
    }

    if (removeNull && value === null) {
      return false;
    }

    if (removeEmptyString && value === '') {
      return false;
    }

    if (removeEmptyObject && typeof value === 'object' && value !== null && Object.keys(value).length === 0) {
      return false;
    }

    return true;
  }

  if (Array.isArray(obj)) {
    return obj
      .map((item) => cleanObjectDeep(item))
      .filter((item) => filterCallback(item)) as unknown as T;
  }

  if (typeof obj === 'object' && obj !== null) {
    const cleanedEntries = Object.entries(obj)
      .map(([key, value]) => [key, cleanObjectDeep(value)])
      .filter(([, value]) => filterCallback(value));

    return Object.fromEntries(cleanedEntries) as T;
  }

  return obj;
}
